import { render, staticRenderFns } from "./DiscountVehicleEnrollment.vue?vue&type=template&id=522e5272&"
import script from "./DiscountVehicleEnrollment.vue?vue&type=script&lang=js&"
export * from "./DiscountVehicleEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports